// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__2Tqlc","text":"Loading_text__KB5NJ","graphic":"Loading_graphic__UHsxC","spin":"Loading_spin__eqMq2"};